// Site content for ACCENT PRESTĂRI SERVICII SRL
// Romanian accounting firm specialized in primary accounting & HR

export const company = {
  name: "Accent Prestări Servicii",
  legalName: "ACCENT PRESTĂRI SERVICII SRL",
  tagline: "Contabilitate primară și resurse umane, cu peste 30 de ani de experiență",
  phone: "0722.933.207",
  phoneHref: "+40722933207",
  whatsapp: "40722933207",
  email: "contactaccentprestariservicii@gmail.com",
  address: "Str. Spătarul Preda nr. 21, Sector 5, București",
  cui: "52453454",
  regCom: "J2025067329000",
  schedule: "Luni – Vineri: 09:00 – 18:00",
};

export const navLinks = [
  { label: "Acasă", path: "/" },
  { label: "Despre noi", path: "/despre-noi" },
  { label: "Servicii", path: "/servicii" },
  { label: "Noutăți", path: "/noutati" },
  { label: "Contact", path: "/contact" },
];

export const heroContent = {
  title: "Contabilitate primară și resurse umane, făcute cum trebuie",
  subtitle:
    "Peste 30 de ani de experiență în contabilitate primară și resurse umane. Ținem evidența, administrăm partea de personal și oferim, când este cazul, și o perspectivă de management asupra afacerii.",
  cta: "Contactează-ne",
  image:
    "https://images.unsplash.com/photo-1524230572899-a752b3835840?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
};

export const aboutContent = {
  title: "Despre noi",
  text: "Cu peste 30 de ani de activitate în contabilitate primară și resurse umane, oferim servicii complete pentru firme mici și mijlocii. Dincolo de partea tehnică — evidența documentelor, statele de plată, REVISAL-ul, declarația 112 — ne implicăm și cu o perspectivă de management, acolo unde clientul are nevoie de o decizie fundamentată. Documentele se transmit digital, pe drive, iar comunicarea rămâne directă, în timp real, la telefon sau pe WhatsApp.",
  cta: "Află mai multe",
  image:
    "https://images.unsplash.com/photo-1522071820081-009f0129c71c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

export const services = [
  {
    id: 1,
    slug: "contabilitate-primara",
    icon: "Calculator",
    title: "Contabilitate primară",
    short:
      "Evidența primară completă — facturi, chitanțe, extrase, deconturi — cu documente organizate și mereu la zi. Transmiterea se face digital, pe drive.",
    description:
      "Documentele se transmit pe drive — poze, scan-uri sau PDF-uri, în funcție de ce este mai practic pentru client. Sunt verificate, înregistrate cronologic și organizate pe secțiuni. Lunar, transmitem o situație clară a intrărilor, ieșirilor și soldurilor. La un eventual control sau la solicitări din partea contabilului financiar, documentele sunt pregătite și accesibile.",
    bullets: [
      "Trimitere digitală, printr-un folder partajat pe drive",
      "Înregistrarea facturilor emise și primite",
      "Registru de casă și evidența avansurilor",
      "Reconciliere pe extrasele bancare și pe deconturi",
      "Documente organizate și arhivate corespunzător",
      "Legătura cu contabilul financiar și cu ANAF",
    ],
  },
  {
    id: 2,
    slug: "resurse-umane-salarizare",
    icon: "Users",
    title: "Resurse umane și salarizare",
    short:
      "Administrarea completă a părții de personal — contracte de muncă, REVISAL, state de plată, fluturași și declarația 112.",
    description:
      "Întocmim contractele de muncă și actele adiționale, actualizăm REVISAL la fiecare modificare, calculăm salariile lunar, generăm fluturașii și depunem declarația 112 la termen. Angajații primesc drepturile salariale corect și la timp, iar firma rămâne mereu în conformitate cu legislația muncii.",
    bullets: [
      "Contracte de muncă și acte adiționale",
      "REVISAL actualizat la fiecare modificare",
      "Salarizare lunară și fluturași generați",
      "Declarația 112, depusă la termen",
      "Adeverințe pentru angajați (medic, credit, șomaj)",
      "Consiliere pe legislația muncii",
    ],
  },
  {
    id: 3,
    slug: "facturare-si-registre",
    icon: "FileText",
    title: "Facturare și registre obligatorii",
    short:
      "Emiterea facturilor, ținerea registrului de casă și a jurnalelor de vânzări și cumpărări, alături de restul registrelor impuse de legislație.",
    description:
      "Facturile sunt emise complet și la timp, iar registrele obligatorii — registrul de casă, jurnalele de vânzări și de cumpărări, precum și celelalte registre cerute de legislație — sunt menținute în ordine pe tot parcursul anului. Documentele rămân accesibile pentru consultare și pentru raportările fiscale, fără riscul de a se acumula întârzieri la sfârșitul exercițiului.",
    bullets: [
      "Emiterea facturilor către clienți",
      "Registru de casă și registru de bancă",
      "Jurnale de vânzări și de cumpărări",
      "Toate registrele impuse de legislație",
    ],
  },
  {
    id: 4,
    slug: "consiliere-si-asistenta",
    icon: "MessageCircle",
    title: "Consiliere și asistență",
    short:
      "Suport pentru întrebările curente și pentru deciziile de management — de la aspecte tehnice, până la analiza situațiilor cu impact strategic asupra afacerii.",
    description:
      "Cei peste 30 de ani de activitate în domeniu ne permit să oferim mai mult decât procesarea documentelor. Analizăm împreună situațiile care apar, oferim o perspectivă de management asupra deciziilor importante și răspundem prompt la solicitările curente — pe telefon, pe WhatsApp sau pe email. Obiectivul este ca fiecare decizie să fie luată în cunoștință de cauză.",
    bullets: [
      "Comunicare directă, în timp real (telefon, WhatsApp, email)",
      "Consultanță de management, nu doar tehnică",
      "Asistență la angajări și la încetări de contract",
      "Îndrumare pe documentele primare",
      "Sprijin în relația cu ITM și ANAF",
    ],
  },
];

export const stats = [
  { value: "30+", label: "Ani de experiență" },
  { value: "100%", label: "Termene respectate" },
];

export const whyUs = [
  {
    icon: "Award",
    title: "Peste 30 de ani de experiență",
    text: "Trei decenii de activitate în contabilitate primară și resurse umane. Experiența se traduce în decizii mai bune și în semnalarea la timp a lucrurilor care contează pentru afacere.",
  },
  {
    icon: "MessageCircle",
    title: "Comunicare directă",
    text: "Comunicare directă cu persoana care se ocupă efectiv de contabilitatea firmei. Telefon și WhatsApp, cu răspuns în timp util — fără call-center și fără trasee interne.",
  },
  {
    icon: "Cloud",
    title: "Documente pe drive",
    text: "Documentele se transmit pe drive — poze, scan-uri sau PDF-uri, într-un folder partajat. Fără drumuri la birou, fără dosare fizice, fără printuri suplimentare.",
  },
  {
    icon: "HeartHandshake",
    title: "Colaborări de durată",
    text: "Majoritatea colaborărilor durează ani buni. Cunoașterea firmei, a oamenilor și a contextului face diferența atunci când apar situații care necesită o reacție rapidă.",
  },
];

export const blogPosts = [
  {
    id: 1,
    slug: "documente-primare-cum-le-organizezi",
    title: "Documente primare: cum le organizezi corect de la început",
    excerpt:
      "O evidență primară ordonată de la început scurtează închiderile de lună și reduce riscul de amenzi. Câteva principii esențiale, verificate în practică.",
    image:
      "https://images.unsplash.com/photo-1554224155-6726b3ff858f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    date: "2026-01-15",
    category: "Contabilitate primară",
    content: [
      "Contabilitatea primară începe cu un principiu simplu: fiecare document care intră în firmă trebuie așezat în locul lui în aceeași zi. Facturile de la furnizori, bonurile de combustibil, chitanțele de la prestatori — toate contribuie la evidența primară și au impact asupra închiderii lunare.",
      "Cea mai eficientă structură, confirmată în timp, este cea pe luni. Un folder dedicat fiecărei luni, împărțit pe secțiuni — facturi emise, facturi primite, extrase, casă, diverse — reduce semnificativ timpul de închidere și scoate la iveală eventualele documente lipsă. Diferența dintre o închidere de două ore și una de două zile pleacă de aici.",
      "Facturile electronice necesită o atenție separată. Sistemul RO e-Factura este deja obligatoriu pentru majoritatea tranzacțiilor B2B, iar documentele lăsate în platformă pot ridica probleme la controale sau la închiderea exercițiului. Recomandarea este ca acestea să fie descărcate lunar și arhivate împreună cu restul documentelor.",
      "Când documentele încep să depășească ritmul de organizare, intervenția timpurie a unui specialist reduce mult timpul și costul recuperării. O evidență primară ordonată nu este o chestiune de estetică — este garanția că firma poate face față unui control fiscal fără improvizații.",
    ],
  },
  {
    id: 2,
    slug: "revisal-si-declaratia-112",
    title: "REVISAL și declarația 112: ce trebuie să știi ca angajator",
    excerpt:
      "Două obligații lunare care nu iartă întârzierile. Ce sunt, când se depun și ce riști dacă le uiți.",
    image:
      "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    date: "2025-12-10",
    category: "Resurse umane",
    content: [
      "REVISAL este registrul general de evidență a salariaților. Orice modificare privind un contract — semnare, act adițional, încetare — trebuie transmisă către Inspecția Muncii înainte ca aceasta să producă efecte. Nu este o formalitate: transmiterea cu întârziere atrage sancțiuni consistente, iar la volume mai mari, sumele nu sunt deloc mici.",
      "Declarația 112 este raportarea lunară către ANAF a impozitului pe venit și a contribuțiilor sociale reținute din salarii. Termenul standard este data de 25 a lunii următoare. Depunerea cu întârziere se sancționează, iar penalizările se cumulează rapid pentru firmele care rămân în urmă.",
      "Cea mai frecventă capcană, în special pentru firmele mici, este întârzierea REVISAL-ului la angajările făcute în grabă. Contractul trebuie transmis cel târziu în ziua începerii activității — nu în ziua următoare, nu la sfârșitul săptămânii. Orice depășire a acestui termen expune firma la sancțiuni.",
      "Pentru o colaborare externă pe partea de resurse umane, condiția esențială este transmiterea informațiilor din timp. Intrările, ieșirile și modificările de contract trebuie comunicate imediat ce sunt cunoscute; cu cât informația ajunge mai rapid la specialist, cu atât mai puține corecții sunt necesare ulterior.",
    ],
  },
  {
    id: 3,
    slug: "cand-sa-externalizezi-contabilitatea-primara",
    title: "Când merită să externalizezi contabilitatea primară",
    excerpt:
      "Nu orice firmă are nevoie de un contabil intern. Semnele că externalizarea este soluția potrivită — și cazurile în care nu este.",
    image:
      "https://images.unsplash.com/photo-1551288049-bebda4e38f71?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    date: "2025-11-20",
    category: "Contabilitate primară",
    content: [
      "Externalizarea contabilității primare devine avantajoasă atunci când volumul de documente este stabil, dar nu suficient de mare pentru a justifica un angajat cu normă întreagă. Costul devine proporțional cu munca efectiv prestată, fără cheltuielile fixe asociate unui post permanent — salariu, contribuții, echipament.",
      "Un alt indicator este calitatea documentelor primare. Facturile lipsă, chitanțele rătăcite sau extrasele neverificate lună de lună semnalează nevoia unei discipline pe care o structură externă o poate impune mai ușor decât un angajat intern, prins între mai multe responsabilități.",
      "Continuitatea reprezintă un avantaj mai puțin discutat, dar important. O colaborare externă nu depinde de concediile sau de plecările neanunțate ale unui singur angajat — activitatea nu se întrerupe, iar predarea între luni rămâne fluidă.",
      "Externalizarea nu este soluția potrivită pentru orice firmă. Companiile cu volume foarte mari și cu un departament contabil intern funcțional nu au motive să schimbe modelul. Pentru firmele mici și mijlocii însă — între prea puțin pentru un angajat dedicat și prea mult pentru gestionarea în regim propriu — merită o discuție înainte ca documentele să scape de sub control.",
    ],
  },
];

export const servicesPageImage =
  "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";
